var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inactive-tag",style:({
    position: _vm.position,
    top: _vm.top + 'px',
    left: _vm.left + 'px',
    right: _vm.right + 'px'
  })},[_vm._v("\n  Inactive\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22e934c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Atoms/InactiveTag.vue
// module id = null
// module chunks = 